
import { React } from 'react'
import { FullScreen, useFullScreenHandle } from 'react-full-screen'
import { MenuExportacao } from '../../../../components/MenuExportacao'
import { format, parseISO } from 'date-fns'
import { useRef } from 'react'
import { useState } from 'react'
import { ModalDetalhes } from '../ModalDetalhes'
import { SVGPDF } from '../../../../components/SVG/SVGPDF'

export function GridRegistros(props) {
    const handle = useFullScreenHandle()
    const printRef = useRef()
    const [isFullScreen, setIsFullScrenn] = useState(false)
    const [orderBy, setOrderBy] = useState('CodigoRegistro')
    const [ascDesc, setAscDesc] = useState(1)
    const [CodigoRegistroSelecionado, setCodigoRegistroSelecionado] = useState([])

    function setFullScreen() {
        if (isFullScreen) {
            handle.exit()
            setIsFullScrenn(false)
        } else {
            handle.enter()
            setIsFullScrenn(true)
        }
    }


    function getValorSomaRegistros() {
        const soma = props.RegistrosBDFiltro
            .reduce((acc, item) => acc + item.Total, 0);

        return Intl.NumberFormat('pt-BR', { minimumFractionDigits: 2 }).format(soma);
    }

    return (
        <FullScreen handle={handle}>
            <div ref={printRef} className='useExport relative'>
                <MenuExportacao
                    filename={'RegistrosGrid'}
                    sheet={'RegistrosGrid'}
                    onlyCSV={true}
                    isFullScreen={isFullScreen}
                    setFullScreen={() => setFullScreen()}
                    idTable="table-to-xls-b2b-contratos"
                />
                <div
                    className={`relative mt-1 bg-gray-50 h-full  w-full ${isFullScreen && 'p-4'} shadow-lg`}

                >
                    <h1 className='bg-gradient-to-r rounded-t-md from-slate-900 to-slate-700 text-white-100 font-semibold p-2'>
                        Relação de Contratos (Clique no registro para exibir os itens)
                    </h1>
                    <div className="flex flex-col h-full">
                        <div className={`overflow-auto ${isFullScreen ? '!max-h-[87vh]' : '!max-h-[30vh]'} `}>
                            <table id="table-to-xls-b2b-contratos" className=" border-separate table-fixed w-full">
                                <thead>
                                    <tr className="text-sm sticky top-0 bg-gradient-to-r from-slate-200 to-slate-100">
                                        <th className="w-[8rem] text-center cursor-pointer" onClick={() => {
                                            setOrderBy('CodigoRegistro')
                                            setAscDesc(ascDesc === 0 ? 1 : 0)
                                        }}>CONTRATO Nº</th>
                                        <th className="w-[5rem]  text-center cursor-pointer" onClick={() => {
                                            setOrderBy('CodigoCliente')
                                            setAscDesc(ascDesc === 0 ? 1 : 0)
                                        }}>CÓD. DEST.</th>
                                        <th className="w-[15rem]  text-center cursor-pointer" onClick={() => {
                                            setOrderBy('Nome')
                                            setAscDesc(ascDesc === 0 ? 1 : 0)
                                        }}>NOME/RAZÃO SOCIAL</th>
                                        <th className="w-[6rem] text-center cursor-pointer" onClick={() => {
                                            setOrderBy('DataEmissao')
                                            setAscDesc(ascDesc === 0 ? 1 : 0)
                                        }}>DATA</th>
                                        <th className="w-[10rem] text-center cursor-pointer" onClick={() => {
                                            setOrderBy('TipoContratos')
                                            setAscDesc(ascDesc === 0 ? 1 : 0)
                                        }}>ATENDIMENTO</th>
                                        <th className="w-[10rem] text-center cursor-pointer" onClick={() => {
                                            setOrderBy('Status')
                                            setAscDesc(ascDesc === 0 ? 1 : 0)
                                        }}>STATUS</th>
                                        <th className="w-[15rem] text-center cursor-pointer" onClick={() => {
                                            setOrderBy('Vendedor')
                                            setAscDesc(ascDesc === 0 ? 1 : 0)
                                        }}>VENDEDOR</th>
                                        <th className="w-[12rem] text-center cursor-pointer" onClick={() => {
                                            setOrderBy('ContatoCliente')
                                            setAscDesc(ascDesc === 0 ? 1 : 0)
                                        }}>CONTATO</th>
                                        <th className="w-[12rem] text-center cursor-pointer" onClick={() => {
                                            setOrderBy('Total')
                                            setAscDesc(ascDesc === 0 ? 1 : 0)
                                        }}>TOTAL R$</th>
                                        <th className="w-[6rem] text-center cursor-pointer" onClick={() => {
                                            setOrderBy('DataInicio')
                                            setAscDesc(ascDesc === 0 ? 1 : 0)
                                        }}>INÍCIO</th>
                                        <th className="w-[6rem] text-center cursor-pointer" onClick={() => {
                                            setOrderBy('DataTermino')
                                            setAscDesc(ascDesc === 0 ? 1 : 0)
                                        }}>TÉRMINO</th>

                                    </tr>
                                </thead>
                                <tbody>
                                    {props.RegistrosBDFiltro?.length > 0
                                        ? (
                                            props.RegistrosBDFiltro.sort((a, b) =>
                                                a[orderBy] > b[orderBy]
                                                    ? ascDesc === 0
                                                        ? 1
                                                        : -1
                                                    : ascDesc === 0
                                                        ? -1
                                                        : 1
                                            ).map((Registro, key) => {
                                                return (
                                                    <tr key={key} onClick={() => setCodigoRegistroSelecionado(Registro)} className="odd:bg-white-100 even:bg-gray-100 cursor-pointer hover:bg-blue-200">
                                                        <td className="text-sm text-center pr-1">{Registro.CodigoRegistro}</td>
                                                        <td className="text-sm text-center pr-1">{Registro.CodigoCliente}</td>
                                                        <td className="text-sm text-left truncate pr-1">{Registro.Nome}</td>
                                                        <td className="text-sm truncate text-center">{format(parseISO(Registro.DataEmissao), 'dd/MM/yyyy')}</td>
                                                        <td className="text-sm text-left truncate pr-1">{Registro.TipoContratos}</td>
                                                        <td className="text-sm text-left truncate pr-1">{Registro.Status}</td>
                                                        <td className="text-sm text-left truncate pr-1">{Registro.Vendedor}</td>
                                                        <td className="text-sm text-left truncate pr-1">{Registro.ContatoCliente}</td>
                                                        <td className="text-sm text-right">{Intl.NumberFormat('pt-BR', { minimumFractionDigits: 2 }).format(Registro.Total)}</td>
                                                        <td className="text-sm truncate text-center">{Registro.DataInicio ? format(parseISO(Registro.DataInicio), 'dd/MM/yyyy') : ''}</td>
                                                        <td className="text-sm truncate text-center">{Registro.DataTermino ? format(parseISO(Registro.DataTermino), 'dd/MM/yyyy') : ''}</td>
                                                    </tr>
                                                )
                                            })
                                        )
                                        : (
                                            <tr className="text-center">
                                                <td className="p-3 italic" colSpan={11}>
                                                    Sem registros
                                                </td>
                                            </tr>
                                        )}
                                </tbody>
                            </table>
                        </div>

                        <div className="bg-white-100 flex-row justify-between  p-2 border-t-2 flex align-middle  bg-gradient-to-r from-slate-200 to-slate-100">
                            <p className="text-sm font-bold">
                                Total = {props.RegistrosBDFiltro?.length.toLocaleString('en-US', { minimumFractionDigits: 0 }).replace(',', '.')}
                            </p>
                            <p className="text-sm font-semibold ">
                                Soma = R$ {getValorSomaRegistros()}
                            </p>
                        </div>
                    </div>

                    <ModalDetalhes
                        setCodigoRegistroSelecionado={setCodigoRegistroSelecionado}
                        registro={CodigoRegistroSelecionado}
                        RegistrosProdutos={props.RegistrosProdutos}
                    />
                </div>
            </div>
        </FullScreen>
    )
}
